import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

import { Tooltip } from "../Tooltip";

import { MinimalTableCell } from "./MinimalTableComponents";

const useStyles = makeStyles()((theme: Theme) => ({
    statusCell: {
        display: "flex",
        alignItems: "center",
    },
    indicator: {
        width: theme.spacing(1),
        height: theme.spacing(8),
        borderRadius: "24px",
    },
}));

type Props = {
    color: string;
    label: string;
};

export const StatusIndicatorCell = ({ color, label }: Props) => {
    const { classes } = useStyles();

    return (
        <MinimalTableCell className={classes.statusCell}>
            <Tooltip placement="right" title={label}>
                <div className={classes.indicator} style={{ backgroundColor: color }} />
            </Tooltip>
        </MinimalTableCell>
    );
};
